import { DescuentoPagoElectronico } from "./DescuentoPagoElectronico";

export class PagoElectronicoDto {
    identificadorFisicoCara: number;
    articuloDescripcion: string;
    fecha: string;
    importe: number;
    cantidad: number;
    preferenceId: string;
    deviceId: string;
    facturaId: string;
    tipoPago: number;
    estado: number;
    paymentId: string;
    legacySiteId: number;
    discounts: DescuentoPagoElectronico[];

    _alias: string; // point
    _numero: string; // point
}